import angular from "angular";

angular.module("ticketco/common/section", ["ticketco/common"]);
